import React from 'react';
import Breadcrumb from './Breadcrumb';

const BlogPost = ({ breadcrumbItems, title, date, content, cta, nextPost, prevPost }) => (
  <div className="blog-post">
    <Breadcrumb items={breadcrumbItems} />
    <div className="blog-post__container">
      <div className="blog-post__header">
        <h1>{title}</h1>
        <p className="blog-post__preamble">
          <strong>{date}</strong>
        </p>
      </div>
      <div className="blog-post__content">
        {content}
        {cta && (
          <div className="blog-post__cta">
            <h2 className="blog-post__cta-title">{cta.title}</h2>
            <p className="blog-post__cta-text">{cta.text}</p>
            <a href={cta.buttonHref} className="btn btn--primary blog-post__cta-btn">
              {cta.buttonText}
            </a>
          </div>
        )}
        <div className="blog-post__nav-links">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              {prevPost && (
                <a href={prevPost.href} className="blog-post__nav-link--bold">
                  ← {prevPost.label}
                </a>
              )}
            </div>
            <div>
              {nextPost && (
                <a href={nextPost.href} className="blog-post__nav-link--bold">
                  {nextPost.label} →
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default BlogPost;
